import { Injectable } from '@angular/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Router } from '@angular/router';
import { Store } from "@ngrx/store";
import { UserService } from "../modules/user";
import { Organisation, OrganisationService } from "../modules/organisation";
import { OrganisationUserActions } from "../modules/organisation-user";
import { Platform } from "@ionic/angular/standalone";

@Injectable({
    providedIn: 'root',
})
export class FcmService {

    private fcmToken = null

    constructor(
        private userService: UserService,
        private router: Router,
        private orgService: OrganisationService,
        private store: Store,
        private platform: Platform,
    ) {
    }

    async init() {

        this.addListeners();
        await this.registerNotifications();
    }

    addListeners = async () => {
        await PushNotifications.addListener('registration', token => {
            if (!this.fcmToken) {
                this.fcmToken = token.value
                this.userService.registerFCM(token.value);
            }
        });

        await PushNotifications.addListener('registrationError', err => {
            console.error('Registration error: ', err.error);
        });

        await PushNotifications.addListener(
            'pushNotificationReceived',
            notification => {
            }
        );

        await PushNotifications.addListener(
            'pushNotificationActionPerformed',
            notification => {
                this.openViewShare(notification.notification.data.id, notification.notification.data.orgId);
            }
        );
    };

    registerNotifications = async () => {
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
            throw new Error('User denied permissions!');
        }

        await PushNotifications.register();
    };

    async openViewShare(shareId: string, orgId: string) {
        if (!shareId) {
            return;
        }
        if (orgId) {
            const orgs: Organisation[] = await this.orgService.getUserOrganisations();
            for (let org of orgs) {
                if (org._id.toString() == orgId) {
                    this.store.dispatch(OrganisationUserActions.switchUserOrganisation({ organisation: org, persist: true }))
                }
            }
        }
        this.router.navigateByUrl('view-share/' + shareId);
    }
}
